// TODO: use end-date ordering!

import hildegard from './composers/1179_hildegard-von-bingen.json';
import vitry from './composers/1361_philippe-de-vitry.json';
import deMachaut from './composers/1377_de-machaut.json';
import landini from './composers/1397_francesco-landini.json';
import dunstable from './composers/1453_john-dunstable.json';
import vivaldi from './composers/1741_vivaldi.json';

// TODO: Renaissance imports

import alessandroScarlatti from './composers/1725_alessandro-scarlatti.json';
import bach from './composers/1750_bach.json';
import giuseppeScarlatti from './composers/1757_giuseppe-scarlatti.json';
import handel from './composers/1759_handel.json';

// Classical imports
import mozart from './composers/1791_mozart.json';
import haydn from './composers/1809_haydn.json';
import beethoven from './composers/1827_beethoven.json';
import schubert from './composers/1828_schubert.json';
import bellini from './composers/1835_bellini.json';
import paganini from './composers/1840_paganini.json';

// Romantic imports
import mendelssohn from './composers/1847_mendelssohn.json';
import strauss1 from './composers/1849_strauss-1.json';
import chopin from './composers/1849_chopin.json';
import schumann from './composers/1856_schumann.json';
import rossini from './composers/1868_rossini.json';
import berlioz from './composers/1869_berlioz.json';
import bizet from './composers/1875_bizet.json';
import mussorgsky from './composers/1881_mussorgsky.json';
import wagner from './composers/1883_wagner.json';
import smetana from './composers/1884_smetana.json';
import liszt from './composers/1886_liszt.json';
import borodin from './composers/1887_borodin.json';
import gounod from './composers/1893_gounod.json';
import tchaikovsky from './composers/1893_tchaikovsky.json';
import bruckner from './composers/1896_bruckner.json';
import brahms from './composers/1897_brahms.json';
import strauss_ii from './composers/1899_strauss-ii.json';
import verdi from './composers/1901_verdi.json';
import dvorak from './composers/1904_dvorak.json';
import grieg from './composers/1907_grieg.json';
import rimsykorsakov from './composers/1908_rimsykorsakov.json';
import mahler from './composers/1911_mahler.json';
import massenet from './composers/1912_massenet.json';
import campina from './composers/1916_campina.json';
// TODO: debussy
import bruch from './composers/1920_bruch.json';
import saintsaens from './composers/1921_saintsaens.json';
import faure from './composers/1924_faure.json';
import puccini from './composers/1924_puccini.json';
import elgar from './composers/1934_elgar.json';
import holst from './composers/1934_holst.json';
import respighi from './composers/1936_respighi.json';
import ravel from './composers/1937_ravel.json';
import rachmaninoff from './composers/1943_rachmaninoff.json';
// TODO: mascagni
import bartok from './composers/1945_bartok.json';
import strauss from './composers/1949_strauss.json';
import sibelius from './composers/1957_sibelius.json';
import vaughanwilliams from './composers/1958_vaughanwilliams.json';

// TODO: add modernist composers from TR web data for composer site!: https://trello.com/b/jeYSbKuj/web-data-for-composer-site

export default [
  {
    "era": "Medieval (500 - 1430)",
    "composers": [
      hildegard,
      vitry,
      deMachaut,
      landini,
      dunstable,
    ]
  },
  {
    "era": "Renaissance (1400 - 1600)",
    "composers": [
      {
        name: "William Byrd (???? - ????) [????]",
        links: [
          { "desc": "", "link": "" },
          { "desc": "Idagio Recordings", "link": "https://app.idagio.com/profiles/william-byrd/recordings?sort=popular" },
        ],
        works: []
      },
      {
        name: "John Downland (???? - ????) [????]",
        links: [
          { "desc": "", "link": "" },
          { "desc": "", "link": "" },
        ],
        works: []
      },
      {
        name: "Giovanni Gabrieli (???? - ????) [????]",
        links: [
          { "desc": "", "link": "" },
          { "desc": "", "link": "" },
        ],
        works: []
      },
      {
        name: "Clement Janequin (???? - ????) [????]",
        links: [
          { "desc": "", "link": "" },
          { "desc": "", "link": "" },
        ],
        works: []
      },
      {
        name: "Orlando de Lassus (???? - ????) [????]",
        links: [
          { "desc": "", "link": "" },
          { "desc": "", "link": "" },
        ],
        works: []
      },
      {
        name: "Johannes Ockoghem (???? - ????) [????]",
        links: [
          { "desc": "", "link": "" },
          { "desc": "", "link": "" },
        ],
        works: []
      },
    ]
  },
  {
    "era": "Baroque (1600 - 1750)",
    "composers": [
      alessandroScarlatti,
      vivaldi,
      bach,
      giuseppeScarlatti,
      handel,
    ]
  },
  {
    "era": "Classical (1730 - 1820)",
    "composers": [
      mozart,
      haydn,
      beethoven,
      schubert,
      bellini,
      paganini,
    ]
  },
  {
    "era": "Romantic (1815 - 1910)",
    "composers": [
      mendelssohn,
      strauss1,
      chopin,
      schumann,
      rossini,
      berlioz,
      bizet,
      // TODO: wieniawski,
      mussorgsky,
      wagner,
      smetana,
      liszt,
      borodin,
      gounod,
      tchaikovsky,
      // TODO: clara schuman
      bruckner,
      brahms,
      strauss_ii,
      verdi,
      dvorak,
      grieg,
      rimsykorsakov,
      mahler,
      massenet,
      campina,
      // TODO: add Debussy
      bruch,
      saintsaens,
      faure,
      puccini,
      // TODO: moszkowski
      elgar,
      holst,
      respighi,
      ravel,
      // TODO: szymanowski
      rachmaninoff,
      // TODO: mascagni
      bartok,
      strauss,
      sibelius,
      vaughanwilliams,
    ]
  },
  {
    "era": "Modernist",
    "composers": [
      {
        name: "Éric Satie (1866 - 1925) [French]",
        links: [
          { "desc": "Wikipedia", "link": "https://en.wikipedia.org/wiki/Erik_Satie" },
          { "desc": "Idagio Playlist", "link": "https://app.idagio.com/playlists/essential-satie" },
        ],
        works: []
      },
      {
        name: "Arnold Schoenberg (1874 - 1951) [Austrian]",
        links: [
          { "desc": "Wikipedia", "link": "https://en.wikipedia.org/wiki/Arnold_Schoenberg" },
          { "desc": "", "link": "" },
        ],
        works: []
      },
      {
        name: "Igor Stravinsky (1882 - 1971) [Russian]",
        links: [
          { "desc": "Wikipedia", "link": "https://en.wikipedia.org/wiki/Igor_Stravinsky" },
          { "desc": "Idagio Playlist", "link": "https://app.idagio.com/playlists/essential-stravinsky" },
        ],
        works: []
      },
      {
        name: "Sergei Prokofiev (1891 - 1953) [Russian]",
        links: [
          { "desc": "Wikipedia", "link": "https://en.wikipedia.org/wiki/Sergei_Prokofiev" },
          { "desc": "Idagio Playlist", "link": "https://app.idagio.com/playlists/essential-prokofiev" },
        ],
        works: []
      },
      {
        name: "George Gershwin (1898 - 1937) [American]",
        links: [
          { "desc": "Wikipedia", "link": "https://en.wikipedia.org/wiki/George_Gershwin" },
          { "desc": "Idagio Playlist", "link": "https://app.idagio.com/playlists/essential-gershwin" },
        ],
        works: []
      },
      {
        name: "Dmitri Shostakovich (1906 - 1975) [Russian]",
        links: [
          { "desc": "Wikipedia", "link": "https://en.wikipedia.org/wiki/Dmitri_Shostakovich" },
          { "desc": "Idagio Playlist", "link": "https://app.idagio.com/playlists/essential-shostakovich" },
        ],
        works: []
      },
    ]
  },
  {
    "era": "Post-modernist (????)",
    "composers": [
      {
        name: "Henryk Górecki (1933 - 2010) [Polish]",
        links: [
          { "desc": "Wikipedia", "link": "https://en.wikipedia.org/wiki/Henryk_G%C3%B3recki" },
          { "desc": "Idagio Playlist", "link": "https://app.idagio.com/playlists/essential-gorecki" },
        ],
        works: []
      },
    ]
  },
];
